import {
  ActivatedRouteSnapshot,
  ResolveFn,
  Route,
  RouterStateSnapshot,
} from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { hasScopesGuard, hasScopesResolver } from '@mds/ngx-auth';
import { ComponentDirtyCheckGuard } from '../../shared/guards/component-dirty-check.guard';
import { ShiftResponse } from '../../shared/services/api-client';
import { shiftResolverFactory } from './resolvers/shift.resolver';

export const shiftRoutes: Route[] = [
  {
    path: '',
    title: _('i18n.Shift.List.Title'),
    loadComponent: () =>
      import('./components/shift-list/shift-list.component').then(
        (m) => m.ShiftListComponent,
      ),
    resolve: { hasWriteScope: hasScopesResolver(['shifts:write']) },
  },
  {
    path: 'create',
    title: _('i18n.Shift.Create.Title'),
    loadComponent: () =>
      import('./components/shift-create/shift-create.component').then(
        (m) => m.ShiftCreateComponent,
      ),
    canDeactivate: [ComponentDirtyCheckGuard],
    canActivate: [hasScopesGuard(['shifts:write'])],
  },
  {
    path: ':shiftId',
    children: [
      {
        path: 'detail',
        resolve: {
          shift: (
            route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot,
          ): ReturnType<ResolveFn<ShiftResponse | undefined>> => {
            const shiftIdRaw = route.paramMap.get('shiftId');
            const shiftId = Number(shiftIdRaw);

            const shiftResolver = shiftResolverFactory(shiftId);
            return shiftResolver(route, state);
          },
          hasWriteScope: hasScopesResolver(['shifts:write']),
        },
        loadComponent: () =>
          import('./components/shift-detail/shift-detail.component').then(
            (m) => m.ShiftDetailComponent,
          ),
      },
      {
        path: 'edit',
        resolve: {
          shift: (
            route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot,
          ): ReturnType<ResolveFn<ShiftResponse | undefined>> => {
            const shiftIdRaw = route.paramMap.get('shiftId');
            const shiftId = Number(shiftIdRaw);

            const shiftResolver = shiftResolverFactory(shiftId);
            return shiftResolver(route, state);
          },
        },
        loadComponent: () =>
          import('./components/shift-edit/shift-edit.component').then(
            (m) => m.ShiftEditComponent,
          ),
        canActivate: [hasScopesGuard(['shifts:write'])],
        canDeactivate: [ComponentDirtyCheckGuard],
      },
    ],
  },
];
